import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  description: {
    fontSize: '14px',
    lineHeight: theme.spacing(2.5),
    color: theme.palette.labraText.description,
    fontWeight: 400,
    letterSpacing: theme.spacing(0.03125),
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 1, 0, 0),
  },
  heading: {
    color: theme.palette.labraText.primary,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  subValue: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    paddingBottom: theme.spacing(3),
  },
  bannerDescription: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    color: theme.palette.labraText.primary,
  },
  switchWrapper: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  enableSwitch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  numberOfDays: {
    width: theme.spacing(39),
  },
  eulaWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    paddingTop: theme.spacing(3),
  },
  eulaDesc: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
  },
}))
